
        <div
            class="dynamic-field form-group"
            [class.has-error]="OBJ_select?.invalid">
            <label class="col-lg-3 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
                <i *ngIf="getHint()" class="fa fa-info-circle"
                   tooltip="{{getHint()|translate}}"
                   placement="top"
                   triggers="click"
                   containerClass="tig-tooltip"
                   delay="50"></i>
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
            <div class="col-lg-8">
                <select #OBJ_select="ngModel"
                        class="form-control"
                        name="OBJ_field_config.name"
                        [(ngModel)]="OBJ_data?.ids[0]"
                        [required]="isRequired()">
                    <option value="">{{"please_select"|translate}}</option>
                    <option *ngFor="let OBJ_option of ARR_options" value="{{OBJ_option.id}}">
                        {{OBJ_option?.title}}
                    </option>
                </select>
                <div *ngIf="OBJ_select?.invalid">
                    {{'oError.sRequired'|translate}}
                </div>
            </div>
        </div>
    